import React from "react";
import Modal from "react-bootstrap/Modal";
//import Moment from 'react-moment';
//import 'moment-timezone';
import { dirname, basename } from "../../utils/commonUtilities";
import {
  getUserTimeZone,
  userGroupUrlCheck,
} from "../../utils/userGroupUrlCheck";
import { converDateToLocal } from "../../utils/commonUtilities";
import { checkPermissions } from "../../utils/permissions";
import AWS from "aws-sdk";
import confirmIcon from "../../assets/images/confirmIcon.svg";
import {
  AWS_ACCESS_KEY_ID,
  AWS_SECRET_ACCESS_KEY,
  AWS_STORAGE_BUCKET_NAME,
  AWS_STORAGE_PDF_FOLDER,
} from "../../configs/awsConfigs";
import {
  LBL_EVENT_PREFIX,
  LBL_SHIFT_PREFIX,
  LBL_QUOTE,
  LBL_CLIENT,
  LBL_PO,
  LBL_CREW,
  LBL_CHIEF,
  LBL_AFFILIATE,
  LBL_CREW_CHIEF,
  LBL_TIME_ZONE,
  LBL_ISSUE_DATE,
  LBL_MODIFIED_DATE,
  LBL_QUOTE_VALID_UNTIL,
  LBL_REQUEST,
  LBL_ACCEPT,
  LBL_REJECT,
  LBL_SEND_TO,
  LBL_TOTAL,
  LBL_HOURS_SHORT,
  LBL_SUB_TOTAL,
  LBL_VAT,
  LBL_BANK_ACC_DET,
  LBL_CONTACT,
  LBL_DISCOUNT,
  LBL_EVENT_SUMMARY,
  LBL_CLIENT_INFORMATION,
  LBL_USER_INFORMATION,
  LBL_COMPANY_NAME,
  LBL_ADDRESS,
  LBL_PHONE_NUMBER,
  LBL_REQUEST_BY,
  LBL_PROJECT_DETAILS,
  LBL_PROJECT_NAME,
  LBL_START_DATE,
  LBL_END_DATE,
  LBL_VENUE_AND_ADDRESS,
  LBL_SHIFT_DETAILS,
  LBL_DOWNLOAD,
  LBL_PROJECT_DURATION,
  LBL_PROJECT_DATE,
  LBL_SAVE,
  LBL_STAFF_PER_VEHICLE,
  LBL_NO_OF_VEHICLES,
  LBL_DISTANCE_TO_LOCATION, 
  LBL_TRAVEL_COST, 
  LBL_TRAVEL_TIME,
  LBL_TRAVEL_COST_TOTAL, 
  LBL_MILES,
  LBL_SHIFT_TOTAL, 
  LBL_SLNUM,
  LBL_TM_FIELD_NAME, 
  LBL_NUM_PASSENGERS, 
  LBL_RATE,
  LBL_DISTANCE,
  LBL_RETURN_COST_INCLUDED,
  LBL_MINS_SHORT,
} from "../../configs/labelConfigs"; // LBL_CREWS, LBL_CHIEFS, LBL_SUBMIT, LBL_EVENT, LBL_SHIFT_LENGTH, LBL_CLOSE, LBL_SUBMIT_MSG_FOR_QUOTE,

import { EVENT_STATUS_CANCELLED, SHIFT_STATUS_CANCELLED, DISCOUNT_TYPE_PERCENTAGE, TM_FIELD_DISTANCE_ID, TM_FIELD_TIME_ID, TM_FIELD_PSNGR_COUNT_ID, TM_FIELD_FLAT_AMOUNT_ID } from "../../configs/staticConfigs";

import {
  showSendQuoteBtn,
  showRequestQuoteBtn,
  showAcceptRejectQuoteBtn,
  showAcceptRejectQuoteBtnAflt,
} from "./eventStatusCheck";
import { convertDecimalToHHMM } from "../../utils/commonUtilities";
import CustomModalHeaderStepper from "./customModalHeaderStepper";
import moment from "moment-timezone";


class PreviewQuote extends React.Component {
  constructor(props) {
    super();
    this.state = {
      showModal: false,
      showStepper: false,
      quotePDFName: "",
    };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleModelClose = this.handleModelClose.bind(this);
    this.sendQuoteToClient = this.sendQuoteToClient.bind(this);
  }

  requestQuoteBtnClick = (eventId) => {
    this.props.requestQuoteBtnClick(eventId);
  };

     formatDecimalToHHMM = (decimal) => {
        if (decimal === null || decimal === undefined || decimal === '') return "00:00";

        const [h, m] = decimal.toString().split(".");
        const hours = h.padStart(2, '0');
        const minutes = m ? m.padStart(2, '0') : '00';

        return `${hours}:${minutes}`;
    };

  handleOpenModal = (stepper) => {
    this.setState({
      showModal: true,
      showStepper: stepper ? stepper : false,
    });
    // this.changeModalHeight();
  };

  handleModelClose = () => {
    this.setState(
      {
        showModal: false,
      },
      () => {
        this.props.resetModalForm();
      }
    );
  };

  getFieldRate = (affiliateFields, fieldId) => {
    const field = affiliateFields.find(f => f.field_id === fieldId);
    return field ? field.field_rate : '';
  };

  getFieldName = (affiliateFields, fieldId) => {
      const field = affiliateFields.find(f => f.field_id === fieldId);
      return field ? field.field_name : '';
  };

  sendQuoteToClient = (eventId) => {
    this.props.sendQuoteToClient(eventId);
  };

  acceptQuote = (eventId) => {
    this.props.acceptQuote(eventId);
  };

  acceptQuoteWithPO = (eventId, poNumber) => {
    this.props.acceptQuoteWithPO(eventId, poNumber);
  };

  rejectQuote = (eventId) => {
    this.props.rejectQuote(eventId);
  };

  downloadQuote = (eventId) => {
    this.props.downloadQuote(eventId);
  };

  downloadQuotePDFBKUP = () => {
    // let pdfURL = 'https://s3-bankend.s3.amazonaws.com/static/quote/quote-10-115-1000-2020-06-11_094744.117767.pdf';
    // let pdfURL = '../../assets/quote-10-115-1000-2020-06-11_094744.117767.pdf';
    if (
      this.props.hasOwnProperty("quoteDownloadFileName") &&
      this.props.quoteDownloadFileName
    ) {
      let pdfURL = this.props.quoteDownloadFileName;
      let folderPath = dirname(pdfURL);
      let pdfName = basename(pdfURL);
      fetch(folderPath).then((response) => {
        response.blob().then((blob) => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = pdfName;
          a.click();
        });
        //window.location.href = response.url;
      });
    } else {
      //console.log('Download File Not Available');
    }
  };

  downloadQuotePDF = () => {
    var s3 = new AWS.S3({
      accessKeyId: AWS_ACCESS_KEY_ID,
      secretAccessKey: AWS_SECRET_ACCESS_KEY,
      region: "ap-south-1",
    });
    let pdfURL =
      AWS_STORAGE_PDF_FOLDER + "quote-10-115-1000-2020-06-11_094744.117767.pdf";
    s3.getObject(
      { Bucket: AWS_STORAGE_BUCKET_NAME, Key: pdfURL },
      function (error, data) {
        if (error != null) {
          alert("Failed to retrieve an object: " + error);
        } else {
          alert("Loaded " + data.ContentLength + " bytes");
          // do something with data.Body
        }
      }
    );
  };

  downloadQuotePDF222 = () => {
    let pdfURL =
      "https://s3-bankend.s3.amazonaws.com/static/quote/quote-10-115-1000-2020-06-11_094744.117767.pdf";
    let folderPath = dirname(pdfURL);
    let pdfName = basename(pdfURL);
    fetch(folderPath).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = pdfName;
        a.click();
      });
      //window.location.href = response.url;
    });
  };

  calculateShiftDetails = (startDateTime, endDateTime) => {
    const start = moment(startDateTime);
    const end = moment(endDateTime);

    const duration = moment.duration(end.diff(start));

    let days = duration.days();
    let hours = duration.hours();
    let minutes = duration.minutes();
    if (hours == 23 && minutes == 59) {
      days += 1;
      hours = 0;
      minutes = 0;
    }

    return days && days > 0 ? `${days}days ${hours}hrs ${minutes}mins` : `${hours}hrs ${minutes}mins`;
  };

  formatDate = (dateStr) => {
    const [day, month, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day).toDateString();
  };

  render() {
    const { eventPreviewQuote, isClientPage } = this.props;
    const userCurrency = this.props.profileCurrency;

    let eventId = "";
    let poNumber = "";
    let quoteNumber = "";
    let affCompanyName = "";
    let affCompanyPhone = "";
    let affCompanyWebsite = "";
    let affCompanyEmail = "";
    let affCompanyLogo = "";
    let affLocation = "";
    let affAdditionalText = "";
    let requestedBy = "";

    let affDynamicFields = [];
    let clientName = "";
    let clientContact = "";
    let clientVenue = "";
    let clientStreetOne = "";
    let clientStreetTwo = "";
    let clientCity = "";
    let clientState = "";
    let clientCountry = "";
    let clientPostcode = "";
    let clientPhone = "";
    let eventTitle = "";
    let eventNumber = "";
    let eventLocationId = 0;
    let eventLocation = "";
    let eventStartDTime = "";
    let eventEndDTime = "";
    let eventReqCrews = 0;
    let eventReqChiefs = 0;
    let eventCancelled = "";
    // let eventVenue = '';
    // let eventStreetOne = '';
    // let eventStreetTwo = '';
    // let eventCity = '';
    // let eventState= '';
    // let eventCountry= '';
    // let eventPostcode= '';

    let shiftdata = [];
    let subTotal = "";
    let overallTotal = "";
    let discountCost = 0;
    let quoteDiscountType = '';
    let quoteDiscountPerc = 0;
    let vatCost = "";
    let eventQuoteStatus = 0;
    let eventStatus = 0;
    let showSendQuote = false;
    let showRequestQuote = false;
    let showAcceptQuote = 0;
    let showRejectQuote = 0;
    let isAffiliateCanAcceptQuote = true; // IF PERMISSION COMES SET THIS VARIABLE ACCORDING TO IT
    let canAcceptQuote = isClientPage ? true : isAffiliateCanAcceptQuote;

    let timeZone = getUserTimeZone(window.location);

    let userGroupData = userGroupUrlCheck(window.location);
    let supervisor_name = "";
    let crew_chief = "";
    if (userGroupData !== undefined) {
      supervisor_name = userGroupData.supervisor_name;
      crew_chief = userGroupData.supervisor_name;
    }
    if (!supervisor_name) {
      supervisor_name = LBL_CHIEF;
      crew_chief = LBL_CREW_CHIEF;
    }

    let is_active = this.props.hasOwnProperty("is_active")
      ? this.props.is_active
      : true;
    let issueDate = "";
    let modifiedDate = "";
    let validUntilDate = "";
    let timeZoneName = timeZone.region;
    let isViewAcceptQuote =
      is_active === true && checkPermissions("acceptquote", "view");
    let signature = "";
    let signatureUrl = "";
    let poOrSign = false;
    if (eventPreviewQuote !== "") {
      eventId = eventPreviewQuote.id;

      if (
        eventPreviewQuote.hasOwnProperty("quote_set") &&
        Array.isArray(eventPreviewQuote.quote_set)
      ) {
        let quote_set = eventPreviewQuote.quote_set[0];
        if (quote_set.valid_until && quote_set.valid_until.trim().length > 0)
          validUntilDate = converDateToLocal(
            quote_set.valid_until,
            "00:00",
            "ddmmyyyyhhmm"
          );
        if (
          quote_set.quote_sent_datetime &&
          quote_set.quote_sent_datetime.trim().length > 0
        )
          issueDate = converDateToLocal(
            quote_set.actual_quote_sent_datetime,
            "00:00",
            "ddmmyyyyhhmm"
          );
        if (
          quote_set.quote_re_sent_datetime &&
          quote_set.quote_re_sent_datetime.trim().length > 0 &&
          quote_set.quote_sent_datetime !== quote_set.quote_re_sent_datetime
        )
          modifiedDate = converDateToLocal(
            quote_set.actual_quote_re_sent_datetime,
            "00:00",
            "ddmmyyyyhhmm"
          );
      }

      poNumber =
        eventPreviewQuote.po_number === null ? "" : eventPreviewQuote.po_number;
      signatureUrl =
        eventPreviewQuote.signature === null ? "" : eventPreviewQuote.signature;

      if (poNumber.length > 0) {
        poOrSign = true;
      }

      if (signatureUrl.length > 0) {
        poOrSign = true;
      }

      quoteNumber = eventPreviewQuote.quote_number;
      let affDynamicFieldsFilter = [];
      if (eventPreviewQuote.affiliate_profile) {
        affCompanyName = eventPreviewQuote.affiliate_profile.company_name;
        affCompanyPhone = eventPreviewQuote.affiliate_profile.phone_number;
        affCompanyWebsite = eventPreviewQuote.affiliate_profile.web_site;
        affCompanyEmail = eventPreviewQuote.affiliate_profile.company_email;
        affCompanyLogo = eventPreviewQuote.affiliate_profile.logo;
        if (eventPreviewQuote.affiliate_profile.location !== null) {
          affLocation = eventPreviewQuote.affiliate_profile.location.location;
          affDynamicFieldsFilter =
            eventPreviewQuote.affiliate_profile.dynamic_fields.filter(
              (x) => x !== null
            );
        }
        if (eventPreviewQuote.affiliate_profile.additional_text !== null) {
          affAdditionalText =
            eventPreviewQuote.affiliate_profile.additional_text;
        }
      }

      requestedBy = eventPreviewQuote.requested_by;

      if (affDynamicFieldsFilter.length > 0) {
        affDynamicFieldsFilter[0].field_details.forEach((item) => {
          if (item.value && item.value.trim()) affDynamicFields.push(item);
        });
      }

      let clientUsers = [];
      if (eventPreviewQuote.client_profile) {
        if (
          eventPreviewQuote.client_contact &&
          eventPreviewQuote.client_contact.length > 0
        ) {
          clientContact = eventPreviewQuote.client_contact;
        } else {
          clientUsers =
            eventPreviewQuote.client_profile.associateusers_set.filter(
              (x) => x !== null
            );
          if (clientUsers.length > 0) {
            clientContact =
              clientUsers[0].user.first_name +
              " " +
              clientUsers[0].user.last_name;
          }
        }

        clientName = eventPreviewQuote.client_profile.company_name;
        // clientPhone = eventPreviewQuote.client_profile.phone_number
        clientPhone = eventPreviewQuote.client_phone_number;
        if (eventPreviewQuote.client_profile.location !== null) {
          clientVenue = eventPreviewQuote.client_profile.location.venue
            ? eventPreviewQuote.client_profile.location.venue
            : "";
          clientStreetOne = eventPreviewQuote.client_profile.location.street1
            ? eventPreviewQuote.client_profile.location.street1
            : "";
          clientStreetTwo = eventPreviewQuote.client_profile.location.street2
            ? eventPreviewQuote.client_profile.location.street2
            : "";
          clientCity = eventPreviewQuote.client_profile.location.city
            ? eventPreviewQuote.client_profile.location.city
            : "";
          clientState = eventPreviewQuote.client_profile.location.state
            ? eventPreviewQuote.client_profile.location.state
            : "";
          clientCountry = eventPreviewQuote.client_profile.location.country
            ? eventPreviewQuote.client_profile.location.country
            : "";
          clientPostcode = eventPreviewQuote.client_profile.location.postcode
            ? eventPreviewQuote.client_profile.location.postcode
            : "";
        }
      }

      eventTitle = eventPreviewQuote.title;
      eventCancelled =
        Number(eventPreviewQuote.status) === Number(EVENT_STATUS_CANCELLED)
          ? " (Cancelled)"
          : "";

      eventNumber =
        eventPreviewQuote.event_number === null
          ? ""
          : eventPreviewQuote.event_number;
      let filteredShift = [];
      if (eventPreviewQuote.shift_set) {
        filteredShift = eventPreviewQuote.shift_set.filter(
          (data) => data != null
        );
      }

      if (eventPreviewQuote.location) {
        eventLocationId = eventPreviewQuote.location.location.id;
        eventLocation = eventPreviewQuote.location.location.location;
      }

      // eventStartDTime     = eventPreviewQuote.start_date;
      // eventEndDTime       = eventPreviewQuote.end_date;
      eventStartDTime = converDateToLocal(
        eventPreviewQuote.start_date,
        "+00:00",
        "ddmmyyyy"
      );
      eventEndDTime = converDateToLocal(
        eventPreviewQuote.end_date,
        "+00:00",
        "ddmmyyyy"
      );
      eventReqCrews = eventPreviewQuote.required_crews;
      eventReqChiefs = eventPreviewQuote.required_chiefs;

      shiftdata = filteredShift;
      let shiftCount = shiftdata.length;

      subTotal = eventPreviewQuote.total_cost;
      overallTotal = eventPreviewQuote.total;
      discountCost = eventPreviewQuote.discount_cost ? eventPreviewQuote.discount_cost : 0;
      quoteDiscountType = eventPreviewQuote?.discount_type ? eventPreviewQuote?.discount_type : '';
      quoteDiscountPerc = eventPreviewQuote?.discount_percentage ? eventPreviewQuote.discount_percentage : 0;
      vatCost = eventPreviewQuote.vat_cost;
      eventStatus = eventPreviewQuote.status;

      if (Number(eventStatus) === Number(EVENT_STATUS_CANCELLED)) {
        subTotal = "0.00";
        overallTotal = "0.00";
        discountCost = "0.00";
        vatCost = "0.00";
      }

      if (
        eventPreviewQuote.quote_set &&
        eventPreviewQuote.quote_set.length > 0
      ) {
        eventQuoteStatus = eventPreviewQuote.quote_set[0].quote_status;
        showSendQuote =
          is_active === true &&
          showSendQuoteBtn(
            isClientPage,
            eventQuoteStatus,
            quoteNumber,
            shiftCount,
            eventStatus
          );

        // FOR AFFILIATES ONLY, QUOTE CAN BE ACCEPTED IN STATUS - QUOTE_SENT, ESTIMATION & REESTIMATION - 30SEP2020
        if (!isClientPage)
          showAcceptQuote = showAcceptRejectQuoteBtnAflt(
            canAcceptQuote,
            eventStatus,
            eventQuoteStatus
          );
        else
          showAcceptQuote =
            is_active === true &&
            showAcceptRejectQuoteBtn(
              canAcceptQuote,
              eventStatus,
              eventQuoteStatus
            );

        showRejectQuote =
          is_active === true &&
          showAcceptRejectQuoteBtn(isClientPage, eventStatus, eventQuoteStatus);
        showRequestQuote =
          is_active === true &&
          showRequestQuoteBtn(isClientPage, eventStatus, eventQuoteStatus);
        signature = eventPreviewQuote.quote_set[0].signature_url;
      }
    }




    return (
      <>
        <Modal
          show={this.state.showModal}
          id={this.props.modalId}
          className="custom-modal "
        >
          <Modal.Header
            closeButton={false}
            className="preview-quote "
          >
            {this.state.showStepper && <CustomModalHeaderStepper activeStep={3} />}
            <div></div>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleModelClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Header>
          <Modal.Body className="preview-quote">
            <div className="row ">
              {this.state.showStepper && (<div className="col-12 px-0 py-3">

              </div>)}
              <div className="col-12 p-0 py-2 d-flex justify-content-between align-items-center">
                <h2 className="crew">{eventTitle} {LBL_EVENT_SUMMARY}</h2>
                {/* <img alt="company-logo" src={"https://picsum.photos/200/300"} className={'rounded'} height={125}/>  */}
                {affCompanyLogo !== null && <img alt="company-logo" src={affCompanyLogo} className={'rounded'} height={125} />}

                {/* <h2 className="crew">{affCompanyName}</h2> */}
              </div>
              {/* <div className="col-6">
              <h2 className="quote-no">
                <span className="textNoBold">{LBL_QUOTE} No : </span>
                {quoteNumber}
              </h2>
            </div> */}
            </div>

            <div className="row">
              <div className="col-12  p-0">
                <table className="preview-quote-table">
                  <thead>
                    <tr>
                      <th>{LBL_CLIENT_INFORMATION}</th>
                      <th>{LBL_USER_INFORMATION}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td align="start" style={{ verticalAlign: "top" }}>
                        <div className="d-flex justify-content-between mb-2 pr-3">
                          <strong>{LBL_COMPANY_NAME}</strong>
                          <div className="text-left " style={{ width: "226px" }}>
                            {clientName}
                          </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 pr-3">
                          <strong>{LBL_ADDRESS}</strong>
                          <div className="text-left " style={{ width: "226px" }}>
                            {[
                              clientVenue,
                              clientStreetOne,
                              clientStreetTwo,
                              clientCity,
                              clientState,
                              clientCountry,
                              clientPostcode,
                            ]
                              .filter((value) => value && value.trim().length > 0) // Filter out empty or null values
                              .join(" ") // Join all values with a space
                              .trim() && ( // Ensure there's content before rendering
                                <>
                                  {[
                                    clientVenue,
                                    clientStreetOne,
                                    clientStreetTwo,
                                    clientCity,
                                    clientState,
                                    clientCountry,
                                    clientPostcode,
                                  ]
                                    .filter(
                                      (value) => value && value.trim().length > 0
                                    )
                                    .join(" ")}
                                </>
                              )}
                          </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 pr-3">
                          <strong>{LBL_PHONE_NUMBER}</strong>
                          <div className="text-left " style={{ width: "226px" }}>
                            {clientPhone}
                          </div>
                        </div>
                      </td>
                      <td align="start" style={{ verticalAlign: "top" }}>

                        <div className="d-flex justify-content-between mb-2 pr-3">
                          <strong>{LBL_REQUEST_BY}</strong>
                          <div className="text-left " style={{ width: "226px" }}>
                            {requestedBy}
                          </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2  pr-3">
                          <strong>{LBL_CONTACT}</strong>
                          <div className="text-left " style={{ width: "226px" }}>
                            {clientContact}
                          </div>
                        </div>
                        {issueDate && issueDate.trim().length > 0 && (
                          <div className="d-flex justify-content-between mb-2 pr-3">
                            <strong>{LBL_ISSUE_DATE}</strong>
                            <div className="text-left " style={{ width: "226px" }}>
                              {issueDate}
                            </div>
                          </div>)}
                        {modifiedDate && modifiedDate.trim().length > 0 && (
                          <div className="d-flex justify-content-between mb-2 pr-3">
                            <strong>{LBL_MODIFIED_DATE}</strong>
                            <div className="text-left " style={{ width: "226px" }}>
                              {modifiedDate}
                            </div>
                          </div>)}
                        {validUntilDate && validUntilDate.trim().length > 0 && (
                          <div className="d-flex justify-content-between mb-2  pr-3">
                            <strong>{LBL_QUOTE_VALID_UNTIL}</strong>
                            <div className="text-left " style={{ width: "226px" }}>
                              {validUntilDate}
                            </div>
                          </div>)}
                        {issueDate &&
                          issueDate.trim().length > 0 &&
                          timeZoneName &&
                          timeZoneName.trim().length > 0 && (
                            <div className="d-flex justify-content-between mb-2  pr-3">
                              <strong>{LBL_TIME_ZONE}</strong>
                              <div className="text-left " style={{ width: "226px" }}>
                                {timeZoneName}
                              </div>
                            </div>)}
                        {poNumber && String(poNumber).trim().length > 0 && (
                          <div className="d-flex justify-content-between  pr-3">
                            <strong>{LBL_PO}</strong>
                            <div className="text-left " style={{ width: "226px" }}>
                              {poNumber}
                            </div>
                          </div>)}

                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row">
              <div className="col-12  p-0 mt-5">
                <table className="preview-quote-table">
                  <thead>
                    <tr>
                      <th colSpan="3">{LBL_PROJECT_DETAILS} </th>
                      <th colSpan="2">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={"5"}>
                        <div className="d-flex justify-content-between mb-4 ">
                          <div
                            className="d-flex flex-column"
                            style={{ width: "226px" }}
                          >
                            <strong>{LBL_PROJECT_NAME}</strong>
                            <div>
                              <span >{eventTitle}</span>{" "}
                              &nbsp; {LBL_EVENT_PREFIX + "" + eventNumber}{" "}
                              <span >{eventCancelled}</span>
                            </div>
                          </div>
                          <div>
                            {this.formatDate(eventStartDTime) !== this.formatDate(eventEndDTime) && (
                              <strong>{LBL_PROJECT_DURATION}</strong>)}
                            <div className="d-flex">
                              {this.formatDate(eventStartDTime) !== this.formatDate(eventEndDTime) && <>
                                <div className="d-flex flex-column pr-5">
                                  <strong>{LBL_START_DATE}</strong>
                                  {eventStartDTime}
                                </div>

                                <div className="d-flex flex-column pr-5">
                                  <strong>{LBL_END_DATE}</strong>
                                  {eventEndDTime}
                                </div>
                              </>
                              }

                              {this.formatDate(eventStartDTime) === this.formatDate(eventEndDTime) && (
                                <div className="d-flex flex-column pr-5">
                                  <strong>{LBL_PROJECT_DATE}</strong>
                                  {eventStartDTime}
                                </div>
                              )}
                              {/* <div className="d-flex flex-column pr-5">
                            <strong>{LBL_SHIFT_LENGTH}</strong>
                            {this.calculateShiftDetails(eventPreviewQuote.start_date,eventPreviewQuote.end_date)}
                          </div> */}
                            </div>
                          </div>
                        </div>

                        <div
                          className="d-flex flex-column"
                          style={{ width: "226px" }}
                        >
                          <strong>{LBL_VENUE_AND_ADDRESS}</strong>
                          {eventLocation}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row">
              <div className="col-12  p-0 mt-5">
                <table className="preview-quote-table">
                  <thead>
                    <tr>
                      <th colSpan="3">{LBL_SHIFT_DETAILS} </th>
                      <th colSpan="2">&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={"5"} style={{ paddingRight: "31px" }}>

                        {shiftdata.map((item, index) => {
                          let total = item.total;
                          let start_datetime = converDateToLocal(
                            item.start_datetime,
                            timeZone.utc_offset,
                            "ddmmyyyyhhmm"
                          );
                          let end_datetime = converDateToLocal(
                            item.end_datetime,
                            timeZone.utc_offset,
                            "ddmmyyyyhhmm"
                          );
                          let required_chiefs = Number(item.required_chiefs);
                          let crew_chief_bonus = Number(item.crew_chief_bonus);
                          let chief_bonus_total = Number(item.chief_bonus_total);
                          if (required_chiefs > 0)
                            crew_chief_bonus =
                              parseFloat(chief_bonus_total) / required_chiefs;
                          let shift_length = convertDecimalToHHMM(item.shift_length);
                          let shiftCancelled =
                            Number(item.status) === Number(SHIFT_STATUS_CANCELLED)
                              ? " (Cancelled)"
                              : "";
                          
                          // TRAVEL COST - SINGLE FIELD ONLY SETTINGS 
                          const travelCostDetails = item.travel_cost_details;
                          let tcSnglFldShowTravelTime = true, tcSnglFldShowTravelDistance = true;
                          let tcSnglFldShowCalcField = true, tcSnglFldFieldSuffix = '', tcSnglFldCalcFieldName = '', tcSnglFldCalcFieldUnit = '', tcSnglFldCalcFieldValue = ''; 

                          if(Object.keys(travelCostDetails).length > 0 && travelCostDetails?.travel_fields.length===1) {
                              if(Number(travelCostDetails.travel_fields[0].field_type)===TM_FIELD_DISTANCE_ID) {
                                  tcSnglFldShowTravelDistance = false;
                                  tcSnglFldCalcFieldName = LBL_DISTANCE_TO_LOCATION; 
                                  tcSnglFldCalcFieldUnit = ' ('+LBL_MILES+')'; 
                                  tcSnglFldCalcFieldValue = travelCostDetails?.travel_distance_miles; 
                              } else if(Number(travelCostDetails.travel_fields[0].field_type)===TM_FIELD_TIME_ID) {
                                  tcSnglFldShowTravelTime = false; 
                                  tcSnglFldCalcFieldName = LBL_TRAVEL_TIME; 
                                  tcSnglFldCalcFieldUnit = ' ('+LBL_HOURS_SHORT+')';
                                  tcSnglFldCalcFieldValue = travelCostDetails?.travel_duration_hh_mm; 
                              } 
                              else if(Number(travelCostDetails.travel_fields[0].field_type)===TM_FIELD_PSNGR_COUNT_ID) {
                                  tcSnglFldCalcFieldName = LBL_STAFF_PER_VEHICLE; 
                                  tcSnglFldCalcFieldUnit = ''; 
                                  tcSnglFldCalcFieldValue = 'staffCount'; 
                              } else if(Number(travelCostDetails.travel_fields[0].field_type)===TM_FIELD_FLAT_AMOUNT_ID) {
                                  tcSnglFldShowCalcField = false; 
                                  tcSnglFldCalcFieldName = ''; 
                                  tcSnglFldCalcFieldUnit = ''; 
                                  tcSnglFldFieldSuffix = ' ('+userCurrency+')';
                              }
                          }

                          // TRAVEL COST - MULTIPLE FIELDS SETTINGS 
                          let tcMultiColSpanValue = 0; 
                          let tcMultiFldShowTravelTime = false, tcMultiFldShowTravelDistance = false, tcMultiFldShowNumPassenger = false;
                          if(Object.keys(travelCostDetails).length > 0 && travelCostDetails?.travel_fields.length > 1) {
                              travelCostDetails.travel_fields.map(tfItem => { 
                                  if(Number(tfItem.field_type)===TM_FIELD_DISTANCE_ID) {
                                      tcMultiFldShowTravelDistance = true;
                                      tcMultiColSpanValue++;
                                  } else if(Number(tfItem.field_type)===TM_FIELD_TIME_ID) {
                                      tcMultiFldShowTravelTime = true; 
                                      tcMultiColSpanValue++;
                                  } 
                                  else if(Number(tfItem.field_type)===TM_FIELD_PSNGR_COUNT_ID) {
                                      tcMultiFldShowNumPassenger = true; 
                                      tcMultiColSpanValue++; 
                                  } 
                                  // else if(Number(tfItem.field_type)===TM_FIELD_FLAT_AMOUNT_ID) {
                                      
                                  // }
                              })
                          }
                          

                          return (
                            <React.Fragment key={index}>


                              <div className="row preview-quote mt-10 border-TopBottom" style={{ background: "white" }}>
                                <div className="col-6">
                                  <p className="line-height-15">
                                    <div className="line-height-15">
                                      <span className="text-bold">{item.title}</span> &nbsp;{" "}
                                      {LBL_SHIFT_PREFIX + "" + item.shift_number}{" "}
                                      <span className="text-bold">{shiftCancelled}</span>
                                      {Number(eventLocationId) !==
                                        Number(item.shift_location.location.id) && (
                                          <div className="widthPerc80">
                                            <small>
                                              {item.shift_location.location.location}
                                            </small>
                                          </div>
                                        )}
                                    </div>
                                  </p>
                                  {/* {(item.start_datetime) && item.start_datetime.trim().length > 0 && <p> <Moment format="DD/MM/YYYY hh:mm">{new Date(item.start_datetime)}</Moment> - <Moment format="DD/MM/YYYY hh:mm">{new Date(item.end_datetime)}</Moment><small></small></p>} */}
                                  {start_datetime && start_datetime.trim().length > 0 && (
                                    <p> {start_datetime + " - " + end_datetime}</p>
                                  )}
                                </div>
                                <div className="col-6 text-right">
                                  {item.affiliate_contact &&
                                    item.affiliate_contact.trim().length > 0 && (
                                      <p>
                                        {LBL_AFFILIATE + " " + LBL_CONTACT} :{" "}
                                        <span className="text-bold">
                                          {" "}
                                          {item.affiliate_contact}
                                        </span>
                                        <small></small>
                                      </p>
                                    )}
                                  {item.client_contact &&
                                    item.client_contact.trim().length > 0 && (
                                      <p>
                                        {LBL_CLIENT + " " + LBL_CONTACT} :{" "}
                                        <span className="text-bold">
                                          {" "}
                                          {item.client_contact}
                                        </span>
                                        <small></small>
                                      </p>
                                    )}

                                  {/* {Number(item.required_crews) > 0 && <p>{LBL_TOTAL+' '+LBL_CREWS+'/'+LBL_CHIEFS} : <span className="text-bold"> {item.required_crews+'/'+item.required_chiefs}</span><small></small></p>}   */}
                                </div>
                              </div>

                              <div className="row" style={{ background: "white" }}>
                                <table className="table">
                                  <tbody>
                                    {item.shift_skills.map((sk, i) => {
                                      let skillHours = convertDecimalToHHMM(sk.hour);
                                      return (
                                        <tr key={i}>
                                          {/* <td className="width-40-percent text-left">
                                              {sk.count + " x " + sk.skill.skill_name}
                                            </td> */}
                                          <td className="width-40-percent text-left">
                                            {sk.count + " x "}
                                            {sk.skill.skill_icon && (
                                              <>
                                                <i className={"fas " + sk.skill.skill_icon}></i>
                                              </>
                                            )}
                                            {" " + sk.skill.skill_name}
                                          </td>

                                          <td className="width-25-percent text-right">
                                            {userCurrency +
                                              " " +
                                              sk.charge_rate +
                                              "/" +
                                              LBL_CREW}
                                          </td>
                                          <td className="width-15-percent text-right">
                                            {skillHours + " " + LBL_HOURS_SHORT.toLowerCase()}
                                          </td>
                                          <td className="width-20-percent text-right">
                                            {userCurrency + " " + sk.charge_rate_total}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                    {required_chiefs > 0 && (
                                      <tr>
                                        <td className="width-40-percent text-left">
                                          {required_chiefs + " x " + crew_chief}
                                        </td>
                                        <td className="width-25-percent text-right">
                                          {userCurrency +
                                            " " +
                                            crew_chief_bonus.toFixed(2) +
                                            "/" +
                                            supervisor_name}
                                        </td>
                                        <td className="width-15-percent text-right">
                                          {shift_length + " " + LBL_HOURS_SHORT.toLowerCase()}
                                        </td>
                                        <td className="width-20-percent text-right">
                                          {userCurrency + " " + chief_bonus_total.toFixed(2)}
                                        </td>
                                      </tr>
                                    )}

                                    {item.expenses.map((other, o) => {
                                      return (
                                        <tr key={o}>
                                          <td className="width-40-percent text-left">
                                            {other.other_expense.name}
                                          </td>
                                          <td className="width-25-percent text-right"></td>
                                          <td className="width-15-percent text-right"></td>
                                          <td className="width-20-percent text-right">
                                            {userCurrency + " " + other.cost}
                                          </td>
                                        </tr>
                                      );
                                    })}


                                    {item.shift_skills && (item.shift_skills.length >= 1) && item?.discount && parseFloat(item.discount) > 0 ?
                                      <>
                                        <tr className="head">
                                          <td colSpan="3" className="text-left text-bold"><b>{LBL_SUB_TOTAL}</b></td>
                                          <td className="width-20-percent text-right text-bold"><b>{userCurrency + " "}{(parseFloat(item.sub_total)).toFixed(2)}</b></td>
                                        </tr>
                                        <tr>
                                          <td colSpan="3" className="text-left text-bold"><b>{LBL_DISCOUNT + (item?.discount_percentage ? (' (' + item.discount_percentage + '%)') : '')}</b></td>
                                          <td className="width-20-percent text-right text-bold"><b>{userCurrency + " "}{(parseFloat(item.discount)).toFixed(2)}</b></td>
                                        </tr>
                                        <tr>
                                          <td scope="row" colSpan="3" className="total pl-3 text-bold text-left">
                                            <span className="text-bold">{LBL_TOTAL}:</span>
                                          </td>
                                          <td className="total text-right  text-bold">
                                            <span className="text-bold">
                                              {userCurrency + " " + total}
                                            </span>
                                          </td>
                                        </tr>
                                      </>
                                      :
                                      <></>
                                    }

                                    {item.shift_skills && (item.shift_skills.length >= 1) && item?.discount && parseFloat(item.discount) == 0 ?
                                      <>
                                        <tr>
                                          <td scope="row" colSpan="3" className="total pl-3 text-bold text-left"
                                          >
                                            <span className="text-bold">{LBL_TOTAL}:</span>
                                          </td>
                                          <td className="total text-right  text-bold">
                                            <span className="text-bold">
                                              {userCurrency + " " + total}
                                            </span>
                                          </td>
                                        </tr>
                                      </> : <></>}

                                  </tbody>
                                </table>
                              </div>

                              {Object.keys(item.travel_cost_details).length === 0 ? null : (
                                <> 
                                
                              {travelCostDetails?.travel_fields.length===1 ? 
                                <>
                                  <div className="row preview-quote bgWhite border-TopBottom" >
                                    <table className="table mt-3 bgWhite" > 
                                      <thead className="bgWhite" >
                                          <tr className="border-bottom bgWhite" >
                                            <th colSpan={5} className="bgWhite">
                                              <div className='d-flex justify-content-between align-items-center w-100 font-14 bgWhite' >
                                                <div className='text-bold'>{LBL_TRAVEL_COST} {travelCostDetails.travel_return_cost_included ? LBL_RETURN_COST_INCLUDED : ''} </div>
                                                {tcSnglFldShowTravelDistance ? <div className='text-normal'>{LBL_DISTANCE_TO_LOCATION}: {parseFloat(travelCostDetails.travel_distance_miles).toFixed(2)} {LBL_MILES}</div> : <></>}
                                                {tcSnglFldShowTravelTime ? <div className='text-normal'>{LBL_TRAVEL_TIME}: {this.formatDecimalToHHMM(travelCostDetails.travel_duration_hh_mm)} {" (" +LBL_HOURS_SHORT +":" +LBL_MINS_SHORT +")"} </div> : <></>}
                                              </div>
                                            </th>
                                          </tr>
                                          <tr className="border-bottom bgWhite" >
                                              <th className="bgWhite">{LBL_SLNUM}</th>
                                              <th className=" text-right bgWhite" >{travelCostDetails.travel_fields[0].field_name+tcSnglFldFieldSuffix}</th>
                                              <th className=" text-right bgWhite" >{tcSnglFldShowCalcField ? <>{tcSnglFldCalcFieldName} <span className='text-normal'>{tcSnglFldCalcFieldUnit}</span></> : <></>}</th> 
                                              <th className=" text-right bgWhite" >{LBL_NO_OF_VEHICLES}</th>
                                              <th className=" text-right bgWhite" >{LBL_TOTAL} ({userCurrency})</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {travelCostDetails.calculation_details.map((tcItem, index) => (
                                              <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td className=" text-right">{parseFloat(tcItem.affiliate_fields[0].field_rate).toFixed(2)}</td>
                                                  <td className=" text-right">{tcSnglFldShowCalcField ? <>{tcSnglFldCalcFieldValue==='staffCount' ? tcItem.staff_per_vehicle : tcSnglFldCalcFieldValue}</> :  <></>}</td>
                                                  <td className=" text-right">{tcItem.no_of_vehicles}</td>
                                                  <td className=" text-right">{parseFloat(tcItem.cost).toFixed(2)}</td>
                                              </tr>))
                                          }
                                          <tr className="head">
                                              <td colSpan={travelCostDetails.travel_fields.length + 3} className="text-left text-bold">
                                                  {LBL_TRAVEL_COST_TOTAL}:
                                              </td>
                                              <td className="text-right width-20-percent text-bold">
                                                  {parseFloat(travelCostDetails.total_travel_cost).toFixed(2)}
                                              </td>
                                          </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div className="row preview-quote px-3  border-TopBottom text-black justify-content-between bgWhite" >
                                    <div className="text-bold">{LBL_SHIFT_TOTAL}:</div>
                                    <div className="text-bold">{userCurrency + " "}{(parseFloat(item.shift_total)).toFixed(2)}</div>
                                  </div>
                                </> 
                                : 
                                <>
                                  <div className="row preview-quote bgWhite border-TopBottom" >
                                    <table className="table mt-3 bgWhite" style={{ width: '100%'}}>
                                        <thead className="bgWhite">
                                            <tr className="bgWhite">
                                                <th colSpan={2} className="bgWhite">
                                                    <div className='d-flex justify-content-between align-items-center w-100 font-14 margin-left-7'>
                                                        <div className='text-bold'>{LBL_TRAVEL_COST} {travelCostDetails.travel_return_cost_included ? LBL_RETURN_COST_INCLUDED : ''}</div>
                                                        {!tcMultiFldShowTravelDistance ? <div className='text-normal'>{LBL_DISTANCE_TO_LOCATION}: {parseFloat(travelCostDetails.travel_distance_miles).toFixed(2)} {LBL_MILES}</div> : null}
                                                        {!tcMultiFldShowTravelTime ? <div className='text-normal mr-2'>{LBL_TRAVEL_TIME}: {this.formatDecimalToHHMM(travelCostDetails.travel_duration_hh_mm)} {" (" +LBL_HOURS_SHORT +":" +LBL_MINS_SHORT +")"} </div> : null}
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="bgWhite">
                                                <td  colSpan={2} className='bgWhite' >
                                                    {travelCostDetails.calculation_details.map((tcItem, index) => (
                                                    <>
                                                    <table className="table bgWhite" style={{ width: '100%' }}>
                                                        <thead className="bgWhite">
                                                            <tr key={'row'+index.toString()} className="bgWhite">
                                                                <th className="bgWhite">{LBL_TM_FIELD_NAME}</th>
                                                                <th className="bgWhite text-right">{LBL_RATE}</th>
                                                                {tcMultiFldShowTravelDistance ? <th className="bgWhite text-right">{LBL_DISTANCE} <span className='text-normal'>{' ('+LBL_MILES+')'}</span> </th>: null}
                                                                {tcMultiFldShowTravelTime ? <th className="bgWhite text-right">{LBL_TRAVEL_TIME} <span className='bgWhite text-normal'>{' ('+LBL_HOURS_SHORT+')'}</span> </th>: null}
                                                                {tcMultiFldShowNumPassenger ? <th className=" text-right">{LBL_NUM_PASSENGERS} </th>: null}
                                                                <th className="bgWhite text-right">{LBL_NO_OF_VEHICLES}</th>
                                                                <th className="bgWhite text-right">{LBL_TOTAL} ({userCurrency})</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="bgWhite">
                                                        {tcItem.affiliate_fields.map(fieldItem => (
                                                            <tr key={fieldItem.field_id}>
                                                                <td>{this.getFieldName(travelCostDetails.travel_fields,fieldItem.field_id)}</td>
                                                                <td className=" text-right">{parseFloat(fieldItem.field_rate).toFixed(2)}</td>
                                                                {Number(fieldItem.field_type)===TM_FIELD_DISTANCE_ID ? <>
                                                                    <td className=" text-right">{parseFloat(travelCostDetails.travel_distance_miles).toFixed(2)}</td>
                                                                    {tcMultiFldShowTravelTime ? <td>&nbsp;</td> : null }
                                                                    {tcMultiFldShowNumPassenger ? <td>&nbsp;</td> : null }
                                                                </> : 
                                                                    Number(fieldItem.field_type)===TM_FIELD_TIME_ID ? <>
                                                                        {tcMultiFldShowTravelDistance ? <td>&nbsp;</td> : null }
                                                                        <td className=" text-right">{parseFloat(travelCostDetails.travel_duration_hh_mm).toFixed(2)}</td> 
                                                                        {tcMultiFldShowNumPassenger ? <td>&nbsp;</td> : null }
                                                                    </> : 
                                                                        Number(fieldItem.field_type)===TM_FIELD_PSNGR_COUNT_ID ? <>
                                                                        {tcMultiFldShowTravelDistance ? <td>&nbsp;</td> : null }
                                                                        {tcMultiFldShowTravelTime ? <td>&nbsp;</td> : null }
                                                                        <td className=" text-right">{tcItem.staff_per_vehicle}</td>
                                                                        </> : 
                                                                            Number(fieldItem.field_type)===TM_FIELD_FLAT_AMOUNT_ID ? <>
                                                                                {tcMultiFldShowTravelDistance ? <td>&nbsp;</td> : null }
                                                                                {tcMultiFldShowTravelTime ? <td>&nbsp;</td> : null }
                                                                                {tcMultiFldShowNumPassenger ? <td>&nbsp;</td> : null }
                                                                            </> :
                                                                <></>  
                                                                }
                                                                <td className=" text-right">{tcItem.no_of_vehicles}</td>
                                                                <td className=" text-right">{parseFloat(fieldItem.field_total).toFixed(2)}</td>
                                                            </tr> 
                                                        ))} 
                                                        <tr className="head">
                                                            <td colSpan={(tcMultiColSpanValue+3)} className="text-bold text-left"> 
                                                                {LBL_SUB_TOTAL}  
                                                            </td>
                                                            <td className="text-bold text-right"> 
                                                                {parseFloat(tcItem.cost).toFixed(2)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    </table>
                                                    </>))
                                                    }
                                                </td>
                                            </tr>
                                            <tr className="head">
                                                <td className="text-bold text-left">
                                                    <div className="margin-left-7">{LBL_TRAVEL_COST_TOTAL}:</div>
                                                </td>
                                                <td className="text-bold text-right width-20-percent">
                                                    <div className="margin-right-8">{parseFloat(travelCostDetails.total_travel_cost).toFixed(2)}</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                  </div>

                                  <div className="row preview-quote px-3  border-TopBottom text-black justify-content-between bgWhite" >
                                    <div className="text-bold">{LBL_SHIFT_TOTAL}:</div>
                                    <div className="text-bold">{userCurrency + " "}{(parseFloat(item.shift_total)).toFixed(2)}</div>
                                  </div>

                                  {/* <div className="row preview-quote px-3  border-TopBottom text-black justify-content-between" style={{ background: "white" }}>
                                    <div className="text-bold">{LBL_TRAVEL_COST}</div>
                                    <div>{LBL_DISTANCE_TO_LOCATION}: <span className="text-bold">{item.travel_cost_details?.travel_distance_miles} {LBL_MILES}</span></div>
                                    <div>{LBL_TRAVEL_TIME}: <span className="text-bold">{item.travel_cost_details?.travel_duration_hh_mm} Hrs</span></div>
                                  </div>
                                  <div className="row " style={{ background: "white" }}>
                                    <table className="table">
                                      <tbody>
                                        <tr className="border-bottom">
                                          <th>#</th>
                                          {item.travel_cost_details.travel_fields.map(field => (
                                            <th key={field.field_id} className="text-right">{field.field_name}</th>
                                          ))}
                                          <th className="text-right">{LBL_STAFF_PER_VEHICLE}</th>
                                          <th className="text-right">{LBL_NO_OF_VEHICLES}</th>
                                          <th className="text-right">{LBL_TOTAL}</th>
                                        </tr>

                                        {item.travel_cost_details.calculation_details.map((calcItem, index) => (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            {item.travel_cost_details.travel_fields.map(field => (
                                              <td key={field.field_id} className="text-right">
                                                {this.getFieldRate(calcItem.affiliate_fields, field.field_id)}
                                              </td>
                                            ))}
                                            <td className="text-right">{calcItem.staff_per_vehicle}</td>
                                            <td className="text-right">{calcItem.no_of_vehicles}</td>
                                            <td className="text-right">{userCurrency + " "}{calcItem.cost.toFixed(2)}</td>
                                          </tr>
                                        ))}
                                        <tr className="head">
                                          <td colSpan={item.travel_cost_details.travel_fields.length + 3} className="text-left text-bold">
                                            {LBL_TRAVEL_COST_TOTAL}:
                                          </td>
                                          <td className="text-right width-20-percent text-bold">
                                            {userCurrency + " "}{item.travel_cost_details?.total_travel_cost.toFixed(2)}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div> 

                                  <div className="row preview-quote px-3  border-TopBottom text-black justify-content-between" style={{ background: "white" }}>
                                    <div className="text-bold">{LBL_SHIFT_TOTAL}:</div>

                                    <div className="text-bold">{userCurrency + " "}{(parseFloat(item.shift_total)).toFixed(2)}</div>
                                  </div>
                                  */}
                                  </>
                                }
                                </>
                              )}

                            </React.Fragment>
                          );
                        })}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row mt-20">
              <div className="col-6 text-left text-bold">
                {signature && <p className="pb-2 pr-2">For {clientName}</p>}
                {signature && (
                  <img
                    alt="company-logo"
                    src={signature}
                    className="img-fliud"
                    style={{ maxHeight: "150px" }}
                  />
                )}
              </div>
              <div className="col-6 text-right  text-bold">
                <p className="pb-2 pr-2">
                  {LBL_SUB_TOTAL} &emsp; {userCurrency + " " + subTotal}
                </p>
                {parseFloat(discountCost) > 0 && (
                  <p className="pb-2 pr-2">
                    {LBL_DISCOUNT}
                    {quoteDiscountType && quoteDiscountType == DISCOUNT_TYPE_PERCENTAGE ? ' (' + quoteDiscountPerc + '%)' : ''}
                    &emsp; &emsp;{" "}
                    {"- " + userCurrency + discountCost}
                  </p>
                )}
                <p className="pb-2 pr-2">
                  {LBL_VAT} &emsp; &emsp; {userCurrency + " " + vatCost}
                </p>
                <p className="pb-2 pr-2">
                  <big>
                    {LBL_TOTAL} &emsp; {userCurrency + " " + overallTotal}
                  </big>
                </p>
              </div>
            </div>
            <div className="row mt-20">
              <div className="col-6">
                {affDynamicFields.length > 0 && (
                  <p className="text-bold">{LBL_BANK_ACC_DET}</p>
                )}
                {affDynamicFields.map((item, inx) => {
                  if (item.value && item.value.trim()) {
                    return (
                      <React.Fragment key={inx}>
                        <p>
                          {item.field_name} : {item.value}
                        </p>
                      </React.Fragment>
                    );
                  } else {
                    return <></>;
                  }
                })}
              </div>
              <div className="col-6 text-left">
                <p>&nbsp;</p>
                <p className="pr-2">{affAdditionalText}</p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className=" row mt-20">
            {/* <div className="col-12">
                <p className=" text-center">
                    {affCompanyPhone!=='' &&
                        <><i className="las la-phone"></i> {affCompanyPhone}  &emsp; </>
                    }
                    {affCompanyWebsite!=='' &&
                        <><i className="las la-globe"></i> {affCompanyWebsite} &emsp; </>
                    }
                    {affCompanyEmail!=='' &&
                        <><i className="las la-envelope"></i> {affCompanyEmail}   </>
                    }
                </p>
               <p>{affLocation}</p>
            </div>  */}

            <button
              type="button"
              className="btn btn-primary"
              onClick={(e) => this.downloadQuote(eventId)}
            >
              {LBL_DOWNLOAD} <i className="las la-download"></i>
            </button>

            {showRequestQuote === true && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => this.requestQuoteBtnClick(eventId)}
              >
                {LBL_REQUEST + " " + LBL_QUOTE}
              </button>
            )}

            {showSendQuote === true && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => this.sendQuoteToClient(eventId)}
              >
                {LBL_SEND_TO + " " + LBL_CLIENT}
              </button>
            )}

            {showAcceptQuote === true &&
              poOrSign == false &&
              isViewAcceptQuote && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={(e) => this.acceptQuote(eventId)}
                >
                  {LBL_ACCEPT + " " + LBL_QUOTE}
                </button>
              )}

            {showAcceptQuote === true &&
              poOrSign == true &&
              isViewAcceptQuote && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={(e) => this.acceptQuoteWithPO(eventId, poNumber)}
                >
                  {LBL_ACCEPT + " " + LBL_QUOTE}
                </button>
              )}

            {showRejectQuote === true && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => this.rejectQuote(eventId)}
              >
                {LBL_REJECT + " " + LBL_QUOTE}
              </button>
            )}

            {this.state.showStepper ? (
              <button
                type="button"
                className="btn btn-primary"
                // onClick={(e) => this.setState({
                //   confirmModal: true,
                // })}
                onClick={this.handleModelClose}
              >
                {LBL_SAVE}
              </button>)
              :

              (
                <button
                  type="button"
                  className="btn btn-secondary btn-cancel"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.handleModelClose}
                >
                  {/* <span aria-hidden="true">&times;</span>  */}
                  Close
                </button>
              )}

          </Modal.Footer>
        </Modal>
        {/* <Modal
        show={this.state.confirmModal}
        id={"confirmModal"}
        className="custom-confirm-modal"
      >    
        <Modal.Body >
         
            
            <img src={confirmIcon}  />
            <div style={{fontSize:"20px",width:"386px",textAlign:"center"}}>{LBL_SUBMIT_MSG_FOR_QUOTE}</div>
            <div className="text-center" style={{fontSize:"24px",fontWeight:"bold",textAlign:"center"}}> CODE {quoteNumber}</div>
            <button
            type="button"
            className="btn btn-secondary btn-cancel"
            data-dismiss="modal"
            aria-label="Close"
            onClick={this.handleModelClose}
          >
            {LBL_CLOSE}
          </button>
     
        </Modal.Body>
      </Modal> */}
      </>
    );
  }
}
export default PreviewQuote;
